/** Presentation only. Native authorities still govern every operation. */
export function reviewBoostV4UiEnabled(environment: Record<string, unknown> | undefined): boolean {
  return environment?.VITE_CLICKDIALOG_REVIEWBOOST_V4_UI === "true";
}
export const REVIEWBOOST_V4_UI_ENABLED = reviewBoostV4UiEnabled(import.meta.env);

/** The build flag is global to Review Boost tenants, never to other products. */
export function reviewBoostV4AppliesToExperience(key: string, enabled: boolean): boolean {
  return enabled && key === "review-boost";
}
